// extracted by mini-css-extract-plugin
export default {"aboutMe":"AboutMe_aboutMe__16CHi","windowSection":"AboutMe_windowSection__gS9gZ","aboutMeSide":"AboutMe_aboutMeSide__2SyNj"};